import * as THREE from 'three'
import Experience from "../Experience";
import vertexFbo from '../../shaders/fbo/vertex.glsl'
import fragmentFbo from '../../shaders/fbo/fragment.glsl'
import vertexParticles from '../../shaders/particles/vertex.glsl'
import fragmentParticles from '../../shaders/particles/fragment.glsl'
import annim from '../Utils/annim'


export default class World {

    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time

        // A generer apres la gestion du loading manager
        this.setupFBO()
        this.setParticles()


        // document.addEventListener('keydown', (e) => {
        //     console.log(e.key);

        //     e.key === 'Enter' ? this.setRound() : null
        //     e.key === 'Backspace' ? this.disapear() : null
        //     e.key === 'ArrowLeft' ? this.pushLeft() : null
        //     e.key === 'ArrowRight' ? this.pushRight() : null
        //     e.key === 'ArrowDown' ? this.pushDown() : null
        //     e.key === 'ArrowUp' ? this.pushUp() : null
        // })










        this.update()

    }



    getRenderTarget() {

        const renderTarget = new THREE.WebGLRenderTarget(this.experience.sizes.width, this.experience.sizes.height, {
            minFilter: THREE.NearestFilter,
            magFilter: THREE.NearestFilter,
            colorSpace: THREE.SRGBColorSpace,
            format: THREE.RGBAFormat,
            type: THREE.FloatType,
        })
        return renderTarget

    }

    setupFBO() {

        this.fbo = this.getRenderTarget()
        this.fbo1 = this.getRenderTarget()

        // this.size = 128 * 2
        this.size = 2048 * 0.75
        // this.size = 1024

        this.data = new Float32Array(this.size ** 2 * 4)
        this.initialPositions = new Float32Array(this.size ** 2 * 4);
        for (let i = 0; i < this.data.length; i++) {
            let i4 = i * 4;

            // Génère des coordonnées aléatoires dans un carré centré autour de (0, 0)
            // Les valeurs sont comprises entre -0.5 et 0.5 pour avoir un carré de côté 1.
            let x = (Math.random() - 0.5); // Multiplication pour ajuster la taille
            let y = (Math.random() - 0.5);


            this.data[i4 + 0] = x * 2 * 3 * Math.tan(0.610865 / 2) * (this.experience.sizes.width / this.experience.sizes.height); // Échelle facultative
            this.data[i4 + 1] = y * 2 * 3 * Math.tan(0.610865 / 2); // Échelle facultative
            this.data[i4 + 2] = 0;        // Position Z reste fixe
            this.data[i4 + 3] = 1;        // Homogène (ou autre usage)
            // 
            this.initialPositions[i4 + 0] = this.data[i4 + 0];
            this.initialPositions[i4 + 1] = this.data[i4 + 1];
            this.initialPositions[i4 + 2] = this.data[i4 + 2];
            this.initialPositions[i4 + 3] = this.data[i4 + 3];
        }

        this.dataTexture = new THREE.DataTexture(this.data, this.size, this.size, THREE.RGBAFormat, THREE.FloatType)
        this.dataTexture.minFilter = THREE.NearestFilter
        this.dataTexture.magFilter = THREE.NearestFilter
        this.dataTexture.needsUpdate = true

        this.infoArray = new Float32Array(this.size ** 2 * 4)

        for (let i = 0; i < this.size; i++) {
            for (let j = 0; j < this.size; j++) {
                let index = (i + j * this.size) * 4
                this.infoArray[index + 0] = this.initialPositions[index + 0];
                this.infoArray[index + 1] = this.initialPositions[index + 1];
                this.infoArray[index + 2] = 1; // Peut être utilisé pour d'autres informations, comme la couleur ou un état
                this.infoArray[index + 3] = 1;
                // this.infoArray[index + 0] = 0.5 + Math.random()
                // this.infoArray[index + 1] = 0.5 + Math.random()
                // this.infoArray[index + 2] = 1
                // this.infoArray[index + 3] = 1

            }
        }

        this.info = new THREE.DataTexture(this.infoArray, this.size, this.size, THREE.RGBAFormat, THREE.FloatType)
        this.info.minFilter = THREE.NearestFilter
        this.info.magFilter = THREE.NearestFilter
        this.info.needsUpdate = true



        this.fboScene = new THREE.Scene()
        this.fboCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, -1, 1)
        this.fboGeometry = new THREE.PlaneGeometry(2, 2)
        this.fboMaterial = new THREE.ShaderMaterial({
            vertexShader: vertexFbo,
            fragmentShader: fragmentFbo,
            uniforms: {
                u_time: new THREE.Uniform(this.experience.time.elapsed),
                u_positions: new THREE.Uniform(this.dataTexture),
                u_info: new THREE.Uniform(this.info),
                u_res: new THREE.Uniform(new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height)),


            }
        })







        this.fboMesh = new THREE.Mesh(this.fboGeometry, this.fboMaterial)
        this.fboScene.add(this.fboCamera)
        this.fboScene.add(this.fboMesh)

        this.experience.renderer.instance.setRenderTarget(this.fbo)
        this.experience.renderer.instance.render(this.fboScene, this.fboCamera)
        this.experience.renderer.instance.setRenderTarget(this.fbo1)
        this.experience.renderer.instance.render(this.fboScene, this.fboCamera)
        this.experience.renderer.instance.setRenderTarget(null)






    }





    setParticles() {
        this.geometry = new THREE.BufferGeometry()
        let vertices = new Float32Array(this.size ** 2 * 3)
        let uvs = new Float32Array(this.size ** 2 * 2)
        for (let i = 0; i < this.size; i++) {
            for (let j = 0; j < this.size; j++) {
                let index = i + j * this.size
                let i3 = index * 3
                let i2 = index * 2
                vertices[i3 + 0] = i / this.size
                vertices[i3 + 1] = j / this.size
                vertices[i3 + 2] = 0
                uvs[i2 + 0] = i / this.size
                uvs[i2 + 1] = j / this.size

            }
        }
        this.geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3))
        this.geometry.setAttribute('uv', new THREE.BufferAttribute(uvs, 2))
        this.material = new THREE.ShaderMaterial({
            vertexShader: vertexParticles,
            fragmentShader: fragmentParticles,
            transparent: true,

            depthTest: false,
            uniforms: {
                u_positions: new THREE.Uniform(this.dataTexture),
                u_info: new THREE.Uniform(this.info),
                u_res: new THREE.Uniform(new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height)),
                u_time: new THREE.Uniform(0),
                u_alpha: new THREE.Uniform(1),
            }
        })
        this.mesh = new THREE.Points(this.geometry, this.material)
        this.scene.add(this.mesh)

        const test = new THREE.Mesh(
            new THREE.PlaneGeometry(1, 1),
            new THREE.MeshBasicMaterial({ color: 'red' })
        )
        test.scale.y = 2 * 3 * Math.tan(0.610865 / 2)
        test.scale.x = test.scale.y * this.experience.sizes.width / this.experience.sizes.height
        test.visible = false
        this.scene.add(test)
    }




    update() {
        this.fboMaterial.uniforms.u_positions.value = this.fbo1.texture
        this.material.uniforms.u_positions.value = this.fbo.texture
        this.experience.renderer.instance.setRenderTarget(this.fbo)
        this.experience.renderer.instance.render(this.fboScene, this.fboCamera)
        this.experience.renderer.instance.setRenderTarget(null)

        this.fboMaterial.uniforms.u_time.value = this.experience.time.elapsed * 0.001
        this.material.uniforms.u_time.value = this.experience.time.elapsed * 0.001


        let temp = this.fbo
        this.fbo = this.fbo1
        this.fbo1 = temp





    }

}